export default "__VITE_ASSET__DkrtoQMY__"